import { Icon } from "@mui/material";
import DeleteDialog from "components/Dialogs/DeleteDielog";
import useAPI from "hooks/useAPI";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { join } from "../../helpers/functions";
import Table from "../Table/Table";
import scss from "./DataTable.module.scss";
import { useTranslation } from "react-i18next";

export const ActionField = ({ value, actionHandlers }) => {
    let actions = value.split("_");
    const getLabel = (action) => {
        switch (action) {
            case "edit":
                return "edit";
            case "preview":
                return "visibility";
            case "delete":
                return "delete";
            case "list":
                return "list_alt";
            default:
                return "";
        }
    };

    return (
        <div className={scss.actionField}>
            {actions.map((action) => {
                return (
                    <Icon
                        key={action}
                        onClick={(e) => {
                            e.stopPropagation();
                            actionHandlers[action]();
                        }}
                        className={scss.actionIcon}
                    >
                        {getLabel(action)}
                    </Icon>
                );
            })}
        </div>
    );
};

const DataTable = ({ columns, data, apiUrl, maxHeight, actions, navigationKey = ["id"], translateKey }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const api = useAPI();
    const [openDeleteDialog, setOpenDeleteDialog] = useState({ show: false, id: null, mutate: null });
    const handleDeleteConfirm = async () => {
        const refetchAction = columns.find((col) => col.type === "edit_delete")?.refetch;
        api.delete(`${apiUrl}/${openDeleteDialog.id}`)
            .then(() => {
                toast.success("Zapis je uspešno obrisan");
                if (refetchAction) refetchAction();
            })
            .catch(() => toast.warning("Došlo je do greške prilikom brisanja"));

        setOpenDeleteDialog({ show: false, id: null, mutate: 1 });
    };

    // Get the proper class name for the cell
    const getCellClassName = (column) => join([column.align, !column.showOnMobile && "mobile-hidden"]);

    return (
        <>
            <Table maxHeight={maxHeight}>
                <thead>
                    <tr>
                        {(columns ?? []).map((column, index) => (
                            <th key={index} className={getCellClassName(column)}>
                                {t(column.label)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {(data ?? []).map((item, index) => {
                        // Only rows with a "preview" action get the eye icon in the first place -
                        // reuse that same navigate() so clicking anywhere on the row opens the
                        // details page, not just the icon.
                        const hasPreviewAction = (columns ?? []).some((column) => column.field === "action" && column.type?.split("_").includes("preview"));

                        const actionHandlers = {
                            edit: () => {
                                navigate(`${item.id}`);
                            },
                            preview: () => {
                                let actionUrl = actions?.previewUrl ?? "";
                                navigate(`${actionUrl}${navigationKey.map((key) => item[key]).join("/")}`);
                                // navigate(`${actionUrl}${item[navigationKey]}`);
                            },
                            delete: () => {
                                setOpenDeleteDialog({ show: true, id: item.id, mutate: null });
                            },
                            modal: () => {
                                setOpenDeleteDialog({ show: true, id: item.id, mutate: null });
                            },
                            navigateToDetailPage: () => {},
                        };

                        return (
                            <tr key={index} onClick={hasPreviewAction ? actionHandlers.preview : undefined} style={hasPreviewAction ? { cursor: "pointer" } : undefined}>
                                {(columns ?? []).map((column, index) => {
                                    return (
                                        <td key={index} className={getCellClassName(column)}>
                                            {column.field !== "action" ? item[column.field] : <ActionField value={column.type} actionHandlers={actionHandlers} />}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </Table>

            <DeleteDialog
                handleConfirm={handleDeleteConfirm}
                openDeleteDialog={openDeleteDialog}
                setOpenDeleteDialog={setOpenDeleteDialog}
                title={translateKey ? `${translateKey}-delete_dialog-title` : ""}
                // description={translateKey ? `${translateKey}-delete_dialog-description` : ""}
            />
        </>
    );
};

export default DataTable;
